import { styled } from '@acko-tech/building-blocks.ui.common';

const fixedContainer = `
   //left: 0;
   position: fixed;
   //right: 0
   bottom: 0;
   padding:12px 20px;
   margin: auto;
   background: #fff;
   width: 100%;
   min-height: max-content;
   box-sizing: border-box;
`;
export const ButtonTextWrapper = styled.div`
    min-height: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const Wrapper = styled.div<{
    webFixed?: boolean;
    mobFixed?: boolean;
    margin?: string;
    width?: string;
    mWidth?: string;
    background?: string;
}>`
    ${(props: any) => props.webFixed && fixedContainer};
    ${(props: any) => props.background && `background:${props.background}`};
    ${(props: any) => props.margin && `margin: ${props.margin}`};
    ${(props: any) => props.width && `width: ${props.width}`};
    ${(props: any) =>
        props.shadow && `box-shadow: 0px -4px 8px -2px rgba(54, 53, 76, 0.06)`};

    z-index: 999;

    @media (max-width: 700px) {
        left: 0;
        right: 0;
        ${(props: any) => props.mobFixed && fixedContainer};
        ${(props: any) => props.background && `background:${props.background}`};
        ${(props: any) => props.mWidth && `width: ${props.mWidth}`};
        ${(props: any) =>
            props.shadow &&
            `box-shadow: 0px -4px 8px -2px rgba(54, 53, 76, 0.06)`};
    }
    @media (min-width: 600px) {
        max-width: 360px;
    }
`;

export const CTAWrapper = styled.div<{ mMargin?: string }>`
    ${(props: any) => props.mMargin && `margin: ${props.mMargin}`};
`;
